import React from "react";

import svg10 from "../../../../assets/svg/svg10.svg";
import { useNavigate } from "react-router-dom";

function BulkPaymentHero({ items, title, subtitle, svg101, onCtaClick, ctaLabel }) {
  const navigate = useNavigate();

  const handleLogin = async () => {
    window.location.href = "https://app.ndovupay.org/#/login";
  };

  const handleCta = onCtaClick || handleLogin;
  const label = ctaLabel || "Start Now";

  return (
    <>
      <div className="bg-img-2 h-auto pt-[5rem]">
        <div className="lg:px-[5.69rem] px-3 lg:min-h-[53rem] min-h-auto">
          <div className="lg:mt-[5.12rem] mt-[1rem] flex lg:flex-row flex-col justify-between gap-[2rem] lg:gap-[3rem] font-lexendS">
            <div className="w-full lg:max-w-[50%]">
              <div className="text-[#252525] text-[1.75rem] md:text-[2.5rem] lg:text-[3rem] font-[500] leading-tight lg:leading-[3.375rem] max-w-full lg:max-w-[39.8125rem] w-full">
                {title}
              </div>

              <div className="text-[rgba(37,37,37,0.8)] mt-[.5rem] text-[1rem] md:text-[1.125rem] font-[400] leading-[1.625rem] max-w-full lg:max-w-[40rem] w-full">
                {subtitle}
              </div>

              <div className="lg:mt-[4rem] mt-[1rem] flex flex-wrap gap-[.75rem] items-center">
                <button
                  className="cstm-btn-2 !w-auto !min-w-0 group transition-all duration-500 ease-in-out"
                  onClick={() => navigate("/request-demo")}
                >
                  Request a demo
                  <img
                    src={svg10}
                    alt="svg10"
                    className="w-4 h-3 overflow-hidden opacity-0 group-hover:w-[1.25rem] group-hover:opacity-100 group-hover:ml-[.375rem] transition-all duration-500 ease-in-out"
                  />
                </button>
                {onCtaClick && (
                  <button
                    className="cstm-btn !w-auto !min-w-0"
                    onClick={handleCta}
                  >
                    {label}
                  </button>
                )}
                {/* {!onCtaClick && (
                  <button
                    className="cstm-btn-2 !w-auto !min-w-0"
                    onClick={handleLogin}
                  >
                    Start Now <img src={svg10} alt="svg10" />
                  </button>
                )} */}
              </div>
            </div>

            <div className="w-full lg:max-w-[50%] flex items-center justify-center">
              <img
                src={svg101}
                alt="svg101"
                className="max-w-full h-auto object-contain"
              />
            </div>
          </div>

          <div className="mt-[1.97rem] lg:p-[4rem] p-[1.5rem] md:p-[2rem] rounded-[1.25rem] bg-[#1E191B]">
            <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-x-[2rem] lg:gap-x-[4rem] gap-y-[2rem] lg:gap-y-[1.25rem]">
              {items &&
                items?.map((item) => (
                  <div className="flex flex-col w-full">
                    <img
                      className="w-[1.5rem] h-[1.5rem] flex-shrink-0"
                      src={item?.svg}
                      alt={item?.svg}
                    />
                    <div className="mt-[.75rem] text-[1.5rem] md:text-[1.75rem] font-[500] leading-tight md:leading-[2.25rem] text-white">
                      {item?.title}
                    </div>
                    <div className="mt-[1.5rem] text-[#CAC8D4] text-[1rem] font-[400] leading-[1.75rem] max-w-full lg:max-w-[19.75rem] w-full">
                      {item?.desc}
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default BulkPaymentHero;
